/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:pensieve
 */

import * as Types from '../../types/pensieve';

import { api } from 'app/apis/pensieve-gql-api';
export type MentorDash_FetchQueueQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MentorDash_FetchQueueQuery = {
  __typename?: 'Query';
  queue?: {
    __typename?: 'Queue';
    assigned: Array<{
      __typename?: 'QueueAssignment';
      atRisk?: boolean | null;
      expiresAt?: any | null;
      opportunity: {
        __typename?: 'QueueOpportunity';
        project: { __typename?: 'QueueProject'; projectID: string; title: string };
        answerPayment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
        commentPayment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
      };
      question?: { __typename?: 'Question'; id: any } | null;
    }>;
    reviewer?: {
      __typename?: 'QueueReviewer';
      status?: Types.ReviewerStatus | null;
      expiresAt?: any | null;
      options: Array<{
        __typename?: 'QueueOpportunityOption';
        enabled: boolean;
        opportunity: {
          __typename?: 'QueueOpportunity';
          answerPayment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
          commentPayment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
          project: { __typename?: 'QueueProject'; projectID: string; title: string };
        };
      }>;
    } | null;
  } | null;
};

export const MentorDash_FetchQueueDocument = `
    query MentorDash_FetchQueue {
  queue {
    assigned {
      atRisk
      expiresAt
      opportunity {
        project {
          projectID
          title
        }
        answerPayment {
          amount
          currencyCode
        }
        commentPayment {
          amount
          currencyCode
        }
      }
      question {
        id
      }
    }
    reviewer {
      status
      expiresAt
      options {
        enabled
        opportunity {
          answerPayment {
            amount
            currencyCode
          }
          commentPayment {
            amount
            currencyCode
          }
          project {
            projectID
            title
          }
        }
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_FetchQueue: build.query<MentorDash_FetchQueueQuery, MentorDash_FetchQueueQueryVariables | void>({
      query: (variables) => ({ document: MentorDash_FetchQueueDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
